import { render } from "./amount.vue?vue&type=template&id=5fb59747&ts=true"
import script from "./amount.vue?vue&type=script&lang=ts"
export * from "./amount.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__